import React from 'react';

const content = {
	'User Activites': [
		{ title: 'Community Feed', starter: true, pro: true, premium: true },
		{ title: 'Friends Invitation', starter: true, pro: true, premium: true },
		{ title: 'Customization (color, name...)', starter: true, pro: true, premium: true },
		{ title: 'Create all type of posts', starter: true, pro: true, premium: true },
		{ title: 'User notification on answers', starter: true, pro: true, premium: true },
	],
	'Brand Imprint': [
		{ title: 'Challenge', starter: false, pro: true, premium: true },
		{ title: 'Schedule Posts', starter: false, pro: true, premium: true },
		{ title: 'Dashboard', starter: false, pro: true, premium: true },
		{ title: 'Collect Video Review', starter: false, pro: true, premium: true },
		{ title: 'Influencer Page', starter: false, pro: true, premium: true },
		{ title: 'Moderation in Dashboard', starter: false, pro: true, premium: true },
		{ title: 'Feed in Dashboard', starter: false, pro: true, premium: true },
	],
	'Enterprise Prominence': [
		{ title: 'Admin Email notifications', starter: false, pro: false, premium: true },
		{ title: 'Auto Customer Service', starter: false, pro: false, premium: true },
		{ title: 'UGC in PDP', starter: false, pro: false, premium: true },
		{ title: 'Stories', starter: false, pro: false, premium: true },
	],
	// 'Content Moderation': [
	// 	{ title: 'Advanced Look & Feel', starter: true, pro: true, premium: true },
	// ],
	// 'On-Site Display': [
	// 	{ title: 'Site Reviews', starter: true, pro: true, premium: true },
	// ],
	// 'Yotpo Focus': [
	// 	{ title: 'Site Reviews', starter: false, pro: true, premium: true },
	// 	{ title: '2-in-1 Reviews', starter: true, pro: false, premium: false },
	// 	{ title: 'Photo Reviews', starter: true, pro: true, premium: false },
	// 	{ title: 'Email Branding', starter: true, pro: false, premium: true },
	// ],
};
const PlansComparison = props => {
	const { selected, isShopify } = props;
	if (isShopify) {
		delete content['Enterprise Prominence']
	}
	return (
		<>
			<div className='title'>
				<p>Our Plans Comparison</p>
			</div>
			<div>
				<div className='features-table'>
					<div className='table-headers'>
						<div
							className={`header-col ${selected === 'starter' ? 'active' : ''}`}
							ng-reflect-klass='header-col'
						>
							Starter
						</div>
						<div
							className={`header-col ${selected === 'pro' ? 'active' : ''}`}
							ng-reflect-klass='header-col'
						>
							Pro
						</div>
						{!isShopify &&
							<div
								className={`header-col ${selected === 'premium' ? 'active' : ''}`}
								ng-reflect-klass='header-col'
							>
								Premium
							</div>
						}
					</div>
					<div className='shadows'></div>
					<div className='cover'></div>
					{Object.keys(content).map(item => (
						<div className='features-content' key={item}>
							<div className='features-category-header'>
								<p>{item}</p>
								<div className={`fill${isShopify ? '-2' : '-3'} ${selected === 'starter' ? 'active' : ''}`}></div>
								<div className={`fill${isShopify ? '-2' : '-3'} ${selected === 'pro' ? 'active' : ''}`}></div>
								{!isShopify &&
									<div className={`fill-3 ${selected === 'premium' ? 'active' : ''}`}></div>
								}
							</div>
							{content[item].map(e => (
								<div
									className='feature-row'
									hide-delay='0'
									placement='left'
									show-delay='1000'
									key={e.title}
								>
									<div className='feature-col'>
										<span className='feature-name'>{e.title}</span>
									</div>
									<div className={`plan-has-feature ${selected === 'starter' ? 'active' : ''}`}>
										{e.starter && <div className='check'></div>}
									</div>
									<div className={`plan-has-feature ${selected === 'pro' ? 'active' : ''}`}>
										{e.pro && <div className='check'></div>}
									</div>
									{!isShopify &&
										<div className={`plan-has-feature ${selected === 'premium' ? 'active' : ''}`}>
											{e.premium && <div className='check'></div>}
										</div>
									}
								</div>
							))}
						</div>
					))}
				</div>
			</div>
		</>
	);
};

export default PlansComparison;
